



















































































































































import { useScrollToComment } from '@getaccept/lib-shared/src/contextual-commenting/composables/scroll-to-comment.composable';
import { useContextualCommentingStore } from '@getaccept/lib-shared/src/contextual-commenting/store/contextual-commenting.store';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import { ButtonType } from '@getaccept/lib-ui';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent, ref } from '@vue/composition-api';
import TopBar from '@getaccept/lib-shared/src/top-bar/components/TopBar.vue';
import CommentHistoryDropdown from '../../contextual-commenting/components/CommentHistoryDropdown.vue';
import ChatButton from './ChatButton.vue';

export default defineComponent({
  components: {
    TopBar,
    CommentHistoryDropdown,
    ChatButton,
  },
  props: {
    logoUrl: {
      type: String,
      default: '',
    },
    recipients: {
      type: Array as PropType<Recipient[]>,
      default: null,
    },
    sender: {
      type: Object as PropType<User>,
      default: null,
    },
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      default: null,
    },
    newCommentsCount: {
      type: Number,
      default: 0,
    },
    showContextualComments: {
      type: Boolean,
      default: false,
    },
    showDownloadOption: {
      type: Boolean,
      default: false,
    },
    showPrintOption: {
      type: Boolean,
      default: false,
    },
    showCallOption: {
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    showChatOption: {
      type: Boolean,
      default: false,
    },
    showInviteOption: {
      type: Boolean,
      default: false,
    },
    showRejectDocumentOption: {
      type: Boolean,
      default: false,
    },
    preventCommentsModification: {
      type: Boolean,
    },
  },
  setup(props) {
    const closeOnAction = ref(true);
    const contextualCommentingStore = useContextualCommentingStore();

    const commentHistoryVisible = computed(
      () => props.showContextualComments && props.recipients && props.recipient && props.sender
    );

    const toggleComments = (value: boolean) => {
      closeOnAction.value = false;
      contextualCommentingStore.commentsHidden = value;
    };

    const { scrollToComment } = useScrollToComment();

    const handleGoToComment = (commentId: string) => {
      scrollToComment(commentId, contextualCommentingStore.showFloatingComments);
    };

    return {
      ButtonType,
      contextualCommentingStore,
      commentHistoryVisible,
      closeOnAction,
      toggleComments,
      handleGoToComment,
    };
  },
});
